import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {onboardingGuideSlideHeight, onboardingGuideSlideWidth} from './onboardingGuideHelpers';

/*
 * Props.
 */

export interface OnboardingGuideSlideNavigationProps {
  navPrimary: React.ReactNode;
  navSecondary?: React.ReactNode;
}

export interface OnboardingGuideSlideProps extends OnboardingGuideSlideNavigationProps {
  backgroundImage?: string;
  children: React.ReactNode;
  width?: string;
  height?: string;
  rightContent?: React.ReactNode;
  isLeftContent?: boolean;
}

/*
 * Style.
 */

const StyledRootDiv = styled.div<{
  $backgroundImage: string | undefined;
  $width: string;
  $height: string;
  $borderRadius: string;
}>`
  width: ${(p) => p.$width};
  height: ${(p) => p.$height};
  /* Displayed before the image is loaded */
  background-color: ${(p) => p.theme.greys.white};
  background-image: ${(p) => (p.$backgroundImage ? `url(${p.$backgroundImage})` : 'none')};
  background-color: ${(p) => p.theme.foreground};
  display: flex;
  flex-direction: row;
  overflow: hidden;
  border-radius: ${(p) => p.$borderRadius};
`;

const StyledMainContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledContentDiv = styled.div`
  flex-grow: 1;
  display: flex;
  padding: 48px 48px 23px 48px;
`;

const StyledNavDiv = styled.div`
  flex: 0 0 65px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const StyledNavSecondaryDiv = styled.div`
  padding-left: 10px;
  color: ${(p) => p.theme.greys.shade70};
  font-weight: ${fontWeights.medium};
`;

const StyledNavPrimaryDiv = styled.div`
  display: flex;
`;

/*
 * Component.
 */

export const OnboardingGuideSlide: FC<OnboardingGuideSlideProps> = (props) => (
  <StyledRootDiv
    $backgroundImage={props.backgroundImage}
    $width={props.width ?? (props.isLeftContent ? '542px' : onboardingGuideSlideWidth)}
    $height={props.height ?? onboardingGuideSlideHeight}
    $borderRadius={props.isLeftContent ? 'unset' : '16px'}
  >
    <StyledMainContentDiv>
      <StyledContentDiv>{props.children}</StyledContentDiv>
      <StyledNavDiv>
        <StyledNavSecondaryDiv>{props.navSecondary}</StyledNavSecondaryDiv>
        <StyledNavPrimaryDiv>{props.navPrimary}</StyledNavPrimaryDiv>
      </StyledNavDiv>
    </StyledMainContentDiv>
    {props.rightContent}
  </StyledRootDiv>
);
